import React, { useState } from 'react';
import { Dialog, Dialogs, PropertyGrid, TextInput, Toast } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import LayoutVersions from "../LayoutVersions.js";
import ReplaceDialog from "./ReplaceDialog.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.layout.RenameLayoutEditor');
export default function RenameLayoutEditor(props) {
  const {
    value,
    eventData,
    onChange
  } = props;
  const {
    name
  } = value || {};
  return /*#__PURE__*/_jsx(PropertyGrid, {
    inline: true,
    children: /*#__PURE__*/_jsx(PropertyGrid.Item, {
      newRow: true,
      label: t('name'),
      children: /*#__PURE__*/_jsx(TextInput, {
        value: name,
        size: 24,
        eventData: "name",
        hint: t('hint'),
        acceptKey: acceptVersionKey,
        onChange: evt => {
          onChange({
            value: {
              name: evt.value
            },
            data: eventData
          });
        }
      })
    })
  });
}
function RenameLayoutDialog(props) {
  const {
    show,
    onClose,
    layoutVersion,
    layoutGroup,
    value: currentValue,
    onLayoutRename
  } = props;
  const [value, setValue] = useState(currentValue || {
    name: layoutVersion.name
  });
  const onChange = evt => {
    setValue(evt.value);
  };
  const doRename = () => {
    onLayoutRename({
      layoutGroup,
      layoutVersion,
      newName: value.name
    }).then(() => {
      Toast.success(t('successMessage', {
        name: value.name
      }));
      onClose();
    }, err => {
      Toast.error([t('errorMessage'), err.message]);
    });
  };
  const onOkay = () => {
    if (LayoutVersions.getVersionFrom(value.layoutGroup, value.name, true)) {
      Dialogs.show({
        component: ReplaceDialog,
        props: {
          onReplace: doRename,
          onClose,
          name: value.name
        }
      });
    } else {
      doRename();
    }
  };
  const valid = value?.name != null && value?.name?.trim() !== '';
  return /*#__PURE__*/_jsx(Dialog.Question, {
    title: t('title'),
    closeOnDocumentClick: false,
    show: show,
    okayDisabled: !valid,
    onCancel: onClose,
    onOkay: onOkay,
    onClose: onClose,
    children: /*#__PURE__*/_jsx(RenameLayoutEditor, {
      ...props,
      value: value,
      onChange: onChange
    })
  });
}
function show(props) {
  Dialogs.show({
    component: RenameLayoutDialog,
    props
  });
}
const VERSION_EX = /[a-zA-Z0-9\-. :]/;
function acceptVersionKey(e) {
  return VERSION_EX.test(e.key);
}
RenameLayoutEditor.show = show;